import _ from 'lodash'
import {listToMap, parseItem} from '@/utils/media'
import {IDataSource} from '.'

export function similarTitlesSource<T extends {catalog: string; id: string}>(
  args: T
): IDataSource<T> {
  const {catalog, id} = args

  return {
    sourceID: 'similar',
    key: id,
    args,
    fetch: async () => {
      const params = new URLSearchParams({
        catalog,
        id,
        include_gfp: 'false',
      })
      const response = await fetch(`/api/gfp-result/similar/?${params.toString()}`)
      if (!response.ok) throw new Error('failed to fetch similar titles')
      const data = await response.json()
      return listToMap(_.map(data.similar || [], parseItem))
    },
  }
}
